export enum MSenarioType {    
    ReferenceScenario = 'Reference',
    TargetScenario = 'Target',
    OptionA = 'OptionA',
    OptionB = 'OptionB',
    OptionC = 'OptionC',
    
  }